import get from "lodash.get";
import React, { FC, useEffect } from "react";
import {
	useController,
	useFormContext,
	useFormState,
	useWatch
} from "react-hook-form";
import BannerButtonVariant from "../components/placeholders/BannerButtonVariant";
import BannerVariant from "../components/placeholders/BannerVariant";

interface Props {
	stepNumber: number;
	order: number;
	type: string;
}

const BannerVariantPicker: FC<Props> = ({ stepNumber, order, type }) => {
	const { control, setValue: setBannerVariant } =
		useFormContext<BannerFormState>();

	const { bannerType } = useWatch({ control });

	// Watch button text field (order 2 = index 1) to use as label on style buttons
	const buttonText = useWatch({
		name: `steps.${stepNumber - 1}.fields.1.givenAnswer`,
		control
	});

	const optional = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.optional`
	});

	const isStepDisabled = useWatch({
		name: `steps.${stepNumber - 1}.isStepDisabled`,
		control
	});

	const required =
		isStepDisabled || optional ? false : "Please enter an answer";

	const rules = { required };

	const options = useWatch({
		name: `steps.${stepNumber - 1}.fields.${order - 1}.radioAnswers`,
		control
	});

	const givenAnswer = useWatch({
		name: `steps.${stepNumber - 1}.fields.${order - 1}.givenAnswer`,
		control
	});

	const { field } = useController({
		name: `steps.${stepNumber - 1}.fields.${order - 1}.givenAnswer`,
		control,
		rules
	});

	useEffect(() => {
		if (bannerType === "videoBanner" && field.value === "accent") {
			setBannerVariant(
				`steps.${stepNumber - 1}.fields.${order - 1}.givenAnswer`,
				""
			);
		}
	}, [bannerType]);

	const { errors } = useFormState({ control });

	const isAnswerInvalid = Boolean(
		get(errors, `steps[${stepNumber - 1}].fields[${order - 1}]`, null)
	);

	const handleChange = (value: string) => {
		field.onChange(value);
	};

	return (
		<div
			className={[
				"flex gap-2",
				isAnswerInvalid ? "border border-red-500" : "border border-transparent"
			].join(" ")}
		>
			{type === "buttonVariant" ? (
				<>
					{options?.map((option) => {
						const value = option.name;
						const isChecked = field.value === value;

						return (
							<BannerButtonVariant
								variant={value as any}
								key={value}
								label={buttonText || undefined}
								isSelected={isChecked}
								onChange={() => handleChange(value)}
							/>
						);
					})}
				</>
			) : (
				<>
					{options?.map((option) => {
						if (bannerType === "videoBanner" && option.name === "accent")
							return;

						const value = option.name;
						const isChecked = field.value === value;

						return (
							<BannerVariant
								variant={option.name as any}
								key={option.name}
								isSelected={isChecked}
								onChange={() => handleChange(value)}
							/>
						);
					})}
				</>
			)}
		</div>
	);
};

export default BannerVariantPicker;
